import { render, staticRenderFns } from "./scbConnect.vue?vue&type=template&id=8e5e0bdc&scoped=true&"
import script from "./scbConnect.vue?vue&type=script&lang=js&"
export * from "./scbConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5e0bdc",
  null
  
)

export default component.exports